import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "../../contexts/LanguageContext";

export default function Stats() {
  const { users, auctions, orders, meydanStats, loading } = useSelector((state) => state.dashboard);
  const { t } = useTranslation();

  const stats = [
    {
      name: t("dashboard.stats.totalAppUsers"),
      stat: loading ? '...' : users.totalUsers.toLocaleString()
    },
    {
      name: t("dashboard.stats.androidIos"),
      stat: loading ? '...' : `${users.totalDeviceUsers?.Android || 0}/${users.totalDeviceUsers?.iOS || 0}`
    },
    {
      name: t("dashboard.stats.verifiedUsers"),
      stat: loading ? '...' : users.totalVerified.toLocaleString()
    },
    {
      name: t("dashboard.stats.numberOfAuctions"),
      stat: loading ? '...' : auctions.totalAuctions.toLocaleString()
    },
    {
      name: t("dashboard.stats.liveAuctions"),
      stat: loading ? '...' : auctions.totalLiveAuctions.toLocaleString()
    },
    {
      name: t("dashboard.stats.totalOrders"),
      stat: loading ? '...' : orders.totalOrders.toLocaleString()
    },
    {
      name: t("dashboard.stats.totalProfit"),
      stat: loading ? '...' : `$${meydanStats.totalProfit.toLocaleString()}`
    },
  ];

  return (
    <div>
      <dl className="mt-5 grid grid-cols-2 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow-md md:grid-cols-7 md:divide-y-0 md:divide-x py-2 border border-gray-100 ">
        {stats.map((item) => (
          <div key={item.name} className="px-4 py-2 sm:p-3 text-center">
            <dt className="text-base font-semibold text-themeGray">{item.stat}</dt>
            <dd className="mt-1 text-center md:block">
              <div className="text-xs font-medium text-center text-themeSemiGray">
                {item.name}
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
